export default __webpack_public_path__ + "static/media/maintenance_completed.956e6495.svg";